module.exports = __webpack_public_path__ + "static/img/200322.5df778ba.png";